import React, { useState, useEffect}  from 'react';
import {BannerType} from '../interfaces';
import axios from 'axios';
import {API_TOKEN, API_URL} from '../../constants';

const LeftBanner = (props: { banners: BannerType[] }) => {

    const { banners } = props;


    const bannerClick = (banner: BannerType) => {
        const bannerClickUrl = `${API_URL}/api/?do=bannerclick&id=${banner.id}&token=${API_TOKEN}&lang=nat&format=json`;
        axios.get(bannerClickUrl).then(res => {});
        window.open(banner.target_url, '_blank');
    }


    return (
        <div className='banner-left'>
            {banners.map(banner => {
                const currentUrl = `${API_URL}/banner/${banner.internalurl}/?do=image`;
                return <img src={currentUrl} alt="banner" onClick={()=>bannerClick(banner)}/>
            })}

        </div>
    )
}

export default LeftBanner;
